export default __webpack_public_path__ + "static/media/dark18.8e9583b8.png";